import { Tabs } from "antd";
import { useLocalStorage } from "react-use";

import { LegacyMetrics } from "./legacy-metrics/legacy-metrics";
import { IconicMetrics } from "./iconic-metrics/iconic-metrics";
import { Reports } from "./reports/reports";
import { useHasSalesRole } from "../../hooks/use-has-role";
import { useFlag } from "hooks/use-flag";
import { useMe } from "../../data/use-me";

const customMetrics = {
  iconic: IconicMetrics,
};

const domainDashboardMap = {
  "iconicpowersystems.com": "iconic"
};

export const DashboardRoute = () => {
  const [tab, setTab] = useLocalStorage(
    "LAYOUT_STATE.DASHBOARD.TAB",
    "metrics"
  );

  const hasSalesRole = useHasSalesRole();

  let Metrics = LegacyMetrics;

  const me = useMe();

  const CustomMetrics =
    customMetrics[useFlag("dashboards:custom_metrics", "literal")] ?? customMetrics[domainDashboardMap[me?.email?.split("@")?.[1]]];

  if (CustomMetrics) {
    Metrics = CustomMetrics;
  }

  return (
    <div
      className="sm:w-full 2xl:max-w-[2048px]"
      style={{
        display: "grid",
        gridTemplateColumns: "1fr",
        gridTemplateRows: "64px 1fr",
        height: "100%",
      }}
    >
      <Tabs
        activeKey={tab}
        onChange={setTab}
        tabBarStyle={{
          marginBottom: "0px",
          marginLeft: "24px",
        }}
        items={[
          {
            key: "metrics",
            label: "Metrics",
            children: null,
          },
          ...(hasSalesRole
            ? [
              {
                key: "reports",
                label: "Reports",
                children: null,
              },
            ]
            : []),
        ]}
      />
      <div style={{ gridRowStart: 2, overflowY: "scroll" }}>
        {(tab === "metrics" || tab === "custom_metrics") && <Metrics />}
        {tab === "reports" && <Reports />}
      </div>
    </div>
  );
};
